/**
 * Opt-in CMS alias: entire displayname is `@target key` → resolve that syncfield name
 * (spaces allowed) with the caller's flags (|n:, |p, |ac, …). Returns null when the
 * value is not a pure alias (so existing `((key))` / plain text behaviour is unchanged).
 */
export function parseTranslationAlias(rawText: string | null | undefined): string | null {
    if (!rawText) {
        return null
    }
    const match = /^@([^@]+)$/.exec(rawText.trim())
    const target = match?.[1]?.trim()
    return target ? target : null
}
